import React, { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "@evergis/ui";

import { api } from "evergis/api";
import { EXPORT_FILE_TYPES } from "../constants";

export interface FileDownloaderData {
  downloadHiddenLink: ReactNode;
  downloadInProgress: boolean;
}

export const useFileDownloader = ({
  targetName,
  selectedFormat,
  isReady,
  reset,
  onClickDownload,
}): FileDownloaderData => {
  const fileRef = useRef(null);
  const [downloadUrl, setDownloadUrl] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>();

  const downloadHiddenLink = useMemo(
    () => !!downloadUrl && <Link href={downloadUrl} download={targetName} ref={fileRef} />,
    [downloadUrl, targetName, fileRef],
  );

  const memoFileType = useMemo(
    () => !!selectedFormat?.label && EXPORT_FILE_TYPES.find(t => t.name === selectedFormat.label).fileType,
    [selectedFormat?.label],
  );

  useEffect(() => {
    if (!targetName || !isReady) return;

    if (reset) {
      reset();
    }
    setIsLoading(true);
    api.file
      .downloadFile({ fileName: targetName })
      .then(response => {
        const blob = new Blob([response], { type: memoFileType });
        const url = URL.createObjectURL(blob);

        setDownloadUrl(url);
        setIsLoading(false);
        fileRef.current?.click();
        onClickDownload();
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        setDownloadUrl("");
        setIsLoading(false);
      });
  }, [targetName, isReady, reset, memoFileType, onClickDownload]);

  return { downloadHiddenLink, downloadInProgress: isLoading };
};
